import Cookies from 'js-cookie';
import { NavigateFunction } from 'react-router-dom';
import { action, computed, makeObservable, observable } from 'mobx';

import { AsyncState } from 'shared/libs/state';
import {
   MainAnalyticsChartDataItem,
   MainAnalyticsData,
   MainAnalyticsResponse,
} from './main-analytics.types';
import { MainAnalyticsApiService } from './main-analytics.api-service';

export type MainAnalyticsChartContext = 'cv' | 'simple_cv' | 'registrations' | 'jobs';

export class MainAnalyticsStore {
   readonly loadAnalyticsState = new AsyncState<MainAnalyticsResponse>();
   chartContext: MainAnalyticsChartContext = 'cv';

   constructor(private readonly navigate: NavigateFunction) {
      makeObservable(this, {
         chartContext: observable,
         data: computed,
         chartData: computed,
         isLoading: computed,
         isError: computed,
         setChartContext: action.bound,
      });
   }

   get data(): MainAnalyticsData | null {
      return this.loadAnalyticsState.data?.response ?? null;
   }

   get chartData(): MainAnalyticsChartDataItem[] {
      return this.data?.chart_data ?? [];
   }

   get isLoading(): boolean {
      return this.loadAnalyticsState.status === 'idle' || this.loadAnalyticsState.status === 'pending';
   }

   get isError(): boolean {
      return this.loadAnalyticsState.status === 'error';
   }

   setChartContext(context: MainAnalyticsChartContext): void {
      this.chartContext = context;
   }

   async loadAnalytics(): Promise<void> {
      const tokenKey = Cookies.get('token');

      if (!tokenKey) {
         this.navigate('/admin');
         return;
      }

      await this.loadAnalyticsState.run(() => MainAnalyticsApiService.load());
   }
}
